var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3832 10.4406C13.4233 10.3322 13.5767 10.3322 13.6168 10.4406C14.1212 11.8039 15.1961 12.8788 16.5594 13.3832C16.6678 13.4233 16.6678 13.5767 16.5594 13.6168C15.1961 14.1212 14.1212 15.1961 13.6168 16.5594C13.5767 16.6678 13.4233 16.6678 13.3832 16.5594C12.8788 15.1961 11.8039 14.1212 10.4406 13.6168C10.3322 13.5767 10.3322 13.4233 10.4406 13.3832C11.8039 12.8788 12.8788 11.8039 13.3832 10.4406Z",
    fill: "#4F46E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_617_39895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3832 10.4406C13.4233 10.3322 13.5767 10.3322 13.6168 10.4406C14.1212 11.8039 15.1961 12.8788 16.5594 13.3832C16.6678 13.4233 16.6678 13.5767 16.5594 13.6168C15.1961 14.1212 14.1212 15.1961 13.6168 16.5594C13.5767 16.6678 13.4233 16.6678 13.3832 16.5594C12.8788 15.1961 11.8039 14.1212 10.4406 13.6168C10.3322 13.5767 10.3322 13.4233 10.4406 13.3832C11.8039 12.8788 12.8788 11.8039 13.3832 10.4406Z",
    fill: "#FEE699"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_617_39895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 13.5C15.75 13.5 13.5 14.625 13.5 16.875L16.875 13.5Z",
    fill: "#4F46E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_617_39895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 7,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3832 10.4406C13.4233 10.3322 13.5767 10.3322 13.6168 10.4406C14.1212 11.8039 15.1961 12.8788 16.5594 13.3832C16.6678 13.4233 16.6678 13.5767 16.5594 13.6168C15.1961 14.1212 14.1212 15.1961 13.6168 16.5594C13.5767 16.6678 13.4233 16.6678 13.3832 16.5594C12.8788 15.1961 11.8039 14.1212 10.4406 13.6168C10.3322 13.5767 10.3322 13.4233 10.4406 13.3832C11.8039 12.8788 12.8788 11.8039 13.3832 10.4406Z",
    fill: "#FEE699"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_617_39895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 13.5C11.25 13.5 13.5 12.375 13.5 10.125L10.125 13.5Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 13.5C15.75 13.5 13.5 12.375 13.5 10.125L16.875 13.5Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 13.5C11.25 13.5 13.5 14.625 13.5 16.875L10.125 13.5Z",
    fill: "#4F46E5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64145 1.75617C7.72167 1.53936 8.02833 1.53936 8.10855 1.75617C9.11748 4.48276 11.2672 6.63251 13.9938 7.64144C14.2106 7.72167 14.2106 8.02833 13.9938 8.10855C11.2672 9.11749 9.11749 11.2672 8.10855 13.9938C8.02833 14.2106 7.72167 14.2106 7.64145 13.9938C6.63251 11.2672 4.48276 9.11748 1.75617 8.10855C1.53936 8.02833 1.53936 7.72167 1.75617 7.64145C4.48276 6.63251 6.63251 4.48276 7.64145 1.75617Z",
    fill: "#4F46E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_617_39895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64145 1.75617C7.72167 1.53936 8.02833 1.53936 8.10855 1.75617C9.11748 4.48276 11.2672 6.63251 13.9938 7.64144C14.2106 7.72167 14.2106 8.02833 13.9938 8.10855C11.2672 9.11749 9.11749 11.2672 8.10855 13.9938C8.02833 14.2106 7.72167 14.2106 7.64145 13.9938C6.63251 11.2672 4.48276 9.11748 1.75617 8.10855C1.53936 8.02833 1.53936 7.72167 1.75617 7.64145C4.48276 6.63251 6.63251 4.48276 7.64145 1.75617Z",
    fill: "#FEE699"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_617_39895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 7.875C12.375 7.875 7.875 10.125 7.875 14.625L14.625 7.875Z",
    fill: "#4F46E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_617_39895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64145 1.75617C7.72167 1.53936 8.02833 1.53936 8.10855 1.75617C9.11748 4.48276 11.2672 6.63251 13.9938 7.64144C14.2106 7.72167 14.2106 8.02833 13.9938 8.10855C11.2672 9.11749 9.11749 11.2672 8.10855 13.9938C8.02833 14.2106 7.72167 14.2106 7.64145 13.9938C6.63251 11.2672 4.48276 9.11748 1.75617 8.10855C1.53936 8.02833 1.53936 7.72167 1.75617 7.64145C4.48276 6.63251 6.63251 4.48276 7.64145 1.75617Z",
    fill: "#FEE699"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_617_39895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.125 7.875C3.375 7.875 7.875 5.625 7.875 1.125L1.125 7.875Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 7.875C12.375 7.875 7.875 5.625 7.875 1.125L14.625 7.875Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.125 7.875C3.375 7.875 7.875 10.125 7.875 14.625L1.125 7.875Z",
    fill: "#4F46E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.17c36ae1bdaf987b758e15f2abc66621.svg";
export { ForwardRef as ReactComponent };